import React from 'react';
import { Link } from 'react-router-dom';

export const PARENT_PORTAL = 'parent';
export const FACILITATOR_PORTAL = 'facilitator';

const portalPaths = {
  login: {
    [PARENT_PORTAL]: '/login?role=parent',
    [FACILITATOR_PORTAL]: '/login?role=facilitator',
  },
  signUp: {
    [PARENT_PORTAL]: '/sign-up?role=parent',
    [FACILITATOR_PORTAL]: '/sign-up?role=facilitator',
  },
};

export const getAuthPortal = (location, fallback = PARENT_PORTAL) => {
  const requestedRole = new URLSearchParams(location.search).get('role');

  if (
    requestedRole === PARENT_PORTAL ||
    requestedRole === FACILITATOR_PORTAL
  ) {
    return requestedRole;
  }

  return fallback;
};

const AuthPortalSwitcher = ({ portal, mode = 'login' }) => {
  const paths = portalPaths[mode];

  return (
    <nav className='auth-portal-switcher' aria-label='Choose your program'>
      <div className='auth-portal-options'>
        <Link
          to={paths[PARENT_PORTAL]}
          replace
          aria-current={portal === PARENT_PORTAL ? 'page' : undefined}
          className={`auth-portal-option ${
            portal === PARENT_PORTAL ? 'active' : ''
          }`}
        >
          Parent
        </Link>
        <span className='auth-portal-separator' aria-hidden='true'>
          |
        </span>
        <Link
          to={paths[FACILITATOR_PORTAL]}
          replace
          aria-current={portal === FACILITATOR_PORTAL ? 'page' : undefined}
          className={`auth-portal-option ${
            portal === FACILITATOR_PORTAL ? 'active' : ''
          }`}
        >
          Facilitator
        </Link>
      </div>
    </nav>
  );
};

export default AuthPortalSwitcher;
